import SecureRequest from "utils/securerequest";

export async function getPayorDataByName(payorName: string) {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return await Request.get(`/v3/payer/${payorName}/payers`);
}
